export const slashsendUrl =
  process.env.REACT_APP_ENV === 'local'
    ? 'https://slashsend.loca.lt/'
    : 'https://api.slashsend.io/'
